<template>
	<div>
		<div v-if="showadvancedsearch">
			<div class="row">
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t("student") }}</label>
						<div
							class="pseudo-input mb-3"
						>
							<input
								type="search"
								class="input-bare w-full flex-1"
								placeholder="Student"
								v-if="!search.students.length"
								@click="selectStudent"
								@keyup.enter="selectStudent"
							/>
							<span
								class="badge badge-secondary badge-sm mr-2 mb-2"
								v-for="(student, index) in search.students"
								v-bind:key="index"
							>
								{{ student.displayName }}
								<a @click="removeStudent(student)"><b-icon icon="x"></b-icon></a>
							</span>
							<span
								class="badge badge-primary badge-sm mr-2 mb-2"
								v-if="search.students.length"
								@click="selectStudent"
								@keyup.enter="selectStudent"
								tabindex="0"
								:aria-label="$t('student') + ' ' + $t('add')"
							>
								<b-icon icon="plus"></b-icon> {{ $t("add") }}
							</span>
							<span
								class="badge badge-danger badge-sm mr-2 mb-2"
								v-if="search.students.length"
								@click="search.students=[];updateSearch()"
								@keyup.enter="search.students=[];updateSearch()"
								tabindex="0"
								:aria-label="$t('student') + ' ' + $t('clear-all')"
							>
								<b-icon icon="x"></b-icon> {{ $t('clear-all') }}
							</span>
						</div>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t('teacher') }}</label>
						<div
							class="pseudo-input mb-3"
						>
							<input
								type="search"
								class="input-bare w-full flex-1"
								placeholder="Teacher"
								v-if="!search.teachers.length"
								@click="selectTeacher"
								@keyup.enter="selectTeacher"
								:aria-label="$t('teacher')"
							/>
							<span
								class="badge badge-secondary badge-sm mr-2 mb-2"
								v-for="(teacher, index) in search.teachers"
								v-bind:key="index"
							>
								{{ teacher.displayName }}
								<a @click="removeTeacher(teacher)"><b-icon icon="x"></b-icon></a>
							</span>
							<span
								class="badge badge-primary badge-sm mr-2 mb-2"
								v-if="search.teachers.length"
								@click="selectTeacher"
								@keyup.enter="selectTeacher"
								tabindex="0"
								:aria-label="$t('teacher') + ' ' + $t('add')"
							>
								<b-icon icon="plus"></b-icon> {{ $t("add") }}
							</span>
							<span
								class="badge badge-danger badge-sm mr-2 mb-2"
								v-if="search.teachers.length"
								@click="search.teachers=[];updateSearch()"
								@keyup.enter="search.teachers=[];updateSearch()"
								tabindex="0"
								:aria-label="$t('teacher') + ' ' + $t('clear-all')"
							>
								<b-icon icon="x"></b-icon> {{ $t('clear-all') }}
							</span>
						</div>
					</div>
				</div>
				<div class="col-md-4">
                    <div class="form-group">
						<label>{{ $t('subject') }}</label>
						<div
							class="pseudo-input mb-3"
						>
							<input
								type="search"
								class="input-bare w-full flex-1"
								placeholder="Subject"
								v-if="!search.subjects.length"
								@click="selectSubject"
								@keyup.enter="selectSubject"
								:aria-label="$t('subject')"
							/>
							<span
								class="badge badge-secondary badge-sm mr-2 mb-2"
								v-for="(user, index) in search.subjects"
								v-bind:key="index"
							>
								{{ user.displayName }}
								<a @click="removeSubject(user)"><b-icon icon="x"></b-icon></a>
							</span>
							<span
								class="badge badge-primary badge-sm mr-2 mb-2"
								v-if="search.subjects.length"
								@click="selectSubject"
								@keyup.enter="selectSubject"
								tabindex="0"
								:aria-label="$t('subject') + ' ' + $t('add')"
							>
								<b-icon icon="plus"></b-icon> {{ $t("add") }}
							</span>
							<span
								class="badge badge-danger badge-sm mr-2 mb-2"
								v-if="search.subjects.length"
								@click="search.subjects=[];updateSearch()"
								@keyup.enter="search.subjects=[];updateSearch()"
								tabindex="0"
								:aria-label="$t('subject') + ' ' + $t('clear-all')"
							>
								<b-icon icon="x"></b-icon> {{ $t('clear-all') }}
							</span>
						</div>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t('completed') }}</label>
						<select
							type="text"
							v-model="search.completed"
							class="form-control"
							 @change="updateSearch()"
						>
							<option value="">{{ $t("any") }}</option>
							<option value="y">{{ $t("completed") }}</option>
							<option value="n">{{ $t("not-completed") }}</option>
						</select>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t('reviewed') }}</label>
						<select
							type="text"
							v-model="search.reviewed"
							class="form-control"
							 @change="updateSearch()"
						>
							<option value="">{{ $t("any") }}</option>
							<option value="y">{{ $t("reviewed") }}</option>
							<option value="n">{{ $t("not-reviewed") }}</option>
						</select>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t('signed-off') }}</label>
						<select
							type="text"
							v-model="search.signedoff"
							class="form-control"
							@change="updateSearch()"
						>
							<option value="">{{ $t("any") }}</option>
							<option value="y">{{ $t("signed-off") }}</option>
							<option value="n">{{ $t("not-signed-off") }}</option>
						</select>
					</div>
				</div>
				<div class="col-md-4">
					<MultiselectSearchInput
						:label="$t('workflows')"
						:options="workflows"
						optionValue="id"
						optionLabel="title"
						v-model="search.workflows"
						@input="updateSearch()"
					/>
				</div>
				<div class="col-md-4">
					<MultiselectSearchInput
						:label="$t('form')"
						:options="forms"
						optionValue="id"
						optionLabel="title"
						v-model="search.forms"
						@input="updateSearch()"
					/>
				</div>
			</div>
			<div class="row">
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t("programme") }}</label>
						<select class="form-control" v-model="search.programme" @change="updateSearch()">
							<option :value="null">{{ $t("any") }}</option>
							<option
							v-for="programme in $config.getValue('programmes')"
							:key="programme.Id"
							:value="programme"
							>{{ programme.Name}}
							</option>
						</select>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t("year") }}</label>
						<select class="form-control" v-model="search.year" @change="updateSearch()">
							<option :value="null">{{ $t("any") }}</option>
							<template v-if="search.programme">
								<option
								v-for="year in parseInt(search.programme.CourseLengthYears)"
								:key="year"
								:value="year"
								>{{ year }}
								</option>
								<option :value="parseInt(search.programme.CourseLengthYears) + 1">{{ $t('graduated') }}</option>
							</template>
						</select>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t("group") }}</label>
						<select class="form-control" v-model="search.group" @change="updateSearch()">
							<option :value="null">{{ $t("any") }}</option>
							<option
							v-for="(name, id) in $config.getValue('groups')"
							:key="id"
							:value="id"
							>{{ name }}
							</option>
						</select>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t("workbook") }}</label>
						<select class="form-control" v-model="search.workbookid" @change="updateSearch()">
							<option :value="null">{{ $t("any") }}</option>
							<option
							v-for="workbook in $config.getValue('workbooks')"
							:key="workbook.id"
							:value="workbook.id"
							>{{ workbook.title }}
							</option>
						</select>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t('from') }}</label>
						<input
							type="date"
							v-model="search.date_from"
							class="form-control"
							@change="updateSearch()"
						>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t('to') }}</label>
						<input
							type="date"
							v-model="search.date_to"
							class="form-control"
							@change="updateSearch()"
						>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-8">
				<div class="input-group mb-2">
					<input
						type="text"
						:placeholder="$t('search-ellipses')"
						v-model="search.q"
						class="form-control form-control-lg"
						@keyup.enter="newSearch"
					/>
					<div class="input-group-append">
						<button class="btn btn-primary" type="button" @click="newSearch">
							<b-icon icon="search"></b-icon>
						</button>
						<button
							class="btn btn-outline-primary"
							v-on:click="toggleAdvancedSearch()"
							v-if="canViewAllForms"
						>
							{{ $t("advanced") }}
						</button>
					</div>
				</div>
			</div>
			<div class="col-md-4">
                <MenuModalBtn additionalClasses="btn-lg mb-3 mr-2"/>
				<button class="btn btn-secondary btn-lg mb-3" @click="getFormResponses()"><b-icon icon="arrow-clockwise"></b-icon></button>
				<!--<button class="btn btn-secondary btn-lg mb-3 float-right" @click="downloadFormResponses()"><b-icon icon="download"></b-icon></button>-->
				<div class="float-right">
					<a id="popover-target-download" class="btn btn-secondary btn-lg mr-2 mb-3" tabindex="0">
						<b-icon icon="download"></b-icon>
					</a>
					<b-popover target="popover-target-download" triggers="focus" placement="bottom" ref="popover">
						<template #title>{{ $t('download') }}</template>
						<b-button @click="downloadFormResponses('csv')" class="mr-1 mb-1">{{ $t('csv') }} ({{ $tc('n-max', 1000) }})</b-button>
						<b-button @click="downloadFormResponses('pdf')">{{ $t('pdf') }} ({{ $tc('n-max', 30) }})</b-button>
					</b-popover>
				</div>
			</div>
		</div>

		<InfiniteScroll
			scrollElementId="main"
			type="FormResponse"
			:dataUrl="dataUrl"
			dataProperty="formresponses"
			class="list-group border-radius-2 no-border"
			itemClass="list-group-item"
			@selectItem="selectFormResponse"
			ref="infinitescroll"
			:noResultsText="$t('no-forms-found')"
			idProperty="formresponse_id"
		/>
	</div>
</template>

<script>
import InfiniteScroll from "src/components/InfiniteScroll";
import MenuModalBtn from "src/components/Workflows/MenuModalBtn.vue";

export default {
	components: {
		InfiniteScroll,
        MenuModalBtn 
	},
	data() {
		return {
			search: {
				q: "",
				students: [],
				teachers: [],
                subjects: [],
				completed: "",
				reviewed: "",
				signedoff: "",
				workflows: [],
				forms: [],
				programme: null ,
				year: null ,
				group: null ,
				workbookid: null ,
				date_from: null ,
				date_to: null ,
				savedreport: null
			},
			showadvancedsearch: false,
			workflows: [],
			forms: [],
            users:[]
		};
	},
	mounted() {

		Promise.all([this.getForms(), this.getWorkflows()]).then(() => {
			this.setSearchDefaults();
			if(!this.search.savedreport){
				this.tryGetSavedSearch();
			}
			if('submitter' in this.$route.query || 'signer' in this.$route.query){
				if('submitter' in this.$route.query){
					this.$users.getUserById.call(this, this.$route.query['submitter']).then((user) => {
						if(user){
							this.search.students.push(user);
						}
						this.getFormResponses();
					});
				}
				if('signer' in this.$route.query){
					this.$users.getUserById.call(this, this.$route.query['signer']).then((user) => {
						if(user){
							this.search.teachers.push(user);
						}
						this.getFormResponses();
					});
				}
			} else {
				this.getFormResponses();
			}
		});

	},
	methods: {
		getForms() {
			this.forms = [];
			return this.$cfetch(`${this.$settings.APIBaseURL}/forms/listall`)
			.then((json) => {
				if (json.status == 'SUCCESS') {
					this.forms = json.results
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		getWorkflows() {
			this.$cfetch(`${this.$settings.APIBaseURL}/workflows/list`)
			.then((json) => {
				if (json.status == 'SUCCESS') {
					this.workflows = json.results;
					/*
					json.results.forEach(item => {
						if(item.forms.length){
							item.title = item.workflow.title;
							this.workflows.push(item);
						}
					});
					*/
					/*
					this.workflows = json.results.reduce(item => {
						if(item.forms.length){
							item.title = item.workflow.title;
							return item;
						}
					});
					*/
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		getWorkflowDetails() {
		},
		selectStudent() {
			const self = this;
			this.$users.getStudents.call(this).then((students) => {
				this.$store.commit("openModal", {
					type: "selector",
					title: this.$t("select-a-student"),
					selectCallback: function (selection) {
						const isSelected = self.search.students.find((student, i) => {
							if (student.id === selection.id) {
								self.$delete(self.search.students, i);
								return true;
							}
						});
						if (!isSelected) {
							self.search.students.push(selection);
						}
						self.updateSearch();
					},
					selected: this.search.students,
					data: students,
					captionKey: "displayName",
                    subcaptionKey: "studentid",
					studentSearchFilters: true,
					selectAllBtn: true
				});
			});
		},
		removeStudent(selection) {
			const self = this;
			self.search.students.find((student, i) => {
				if (student.id === selection.id) {
					self.$delete(self.search.students, i);
					self.updateSearch();
					return true;
				}
			});
			return false;
		},
		selectTeacher() {
			const self = this;
			this.$users.getTeachers.call(this).then((teachers) => {
				const processedTeachers = teachers.map((teacher) => {
				if (teacher.status && teacher.status.toLowerCase() === "closed") {
					teacher.subcaption = this.$t("(Closed)");
				}
				return teacher;
				});
				this.$store.commit("openModal", {
				type: "selector",
				title: this.$t("select-a-teacher"),
				selectCallback: function (selection) {
					const isSelected = self.search.teachers.find((teacher, i) => {
					if (teacher.id === selection.id) {
						self.$delete(self.search.teachers, i);
						return true;
					}
					});
					if (!isSelected) {
					self.search.teachers.push(selection);
					}
					self.updateSearch();
				},
				selected: this.search.teachers,
				data: processedTeachers,
				captionKey: "displayName",
				subcaptionKey: "subcaption",
				selectAllBtn: true
				});
			});
		},

        selectSubject() {
			const self = this;
			this.$users.getStudents.call(this).then((subjects) => {
            this.$store.commit("openModal", {
                    type: "selector",
                    title: this.$t("select-a-subject"),
                    selectCallback: function (selection) {
                        const isSelected = self.search.subjects.find((subject, i) => {
                            if (subject.id === selection.id) {
                                self.$delete(self.search.subjects, i);
                                return true;
                            }
                        });
                        if (!isSelected) {
                            self.search.subjects.push(selection);
                        }
                        self.updateSearch();
                    },
                    selected: this.search.subjects,
                    data: subjects,
                    captionKey: "displayName",
                    studentSearchFilters: true,
                    selectAllBtn: true
                });
			});
		},
		removeTeacher(selection) {
			const self = this;
			self.search.teachers.find((teacher, i) => {
				if (teacher.id === selection.id) {
					self.$delete(self.search.teachers, i);
					self.updateSearch();
					return true;
				}
			});
			return false;
		},
        removeSubject(selection) {
			const self = this;
			self.search.subjects.find((subject, i) => {
				if (subject.id === selection.id) {
					self.$delete(self.search.subjects, i);
					self.updateSearch();
					return true;
				}
			});
			return false;
		},
		selectFormtype() {
			const self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: "Select a form type",
				selectCallback: function (selection) {
					const isSelected = self.search.formtypes.find((formtype, i) => {
						if (formtype.value === selection.value ) {
							self.$delete(self.search.formtypes, i);
							return true;
						}
					});
					if (!isSelected) {
						self.search.formtypes.push(selection);
					}
					self.updateSearch();
				},
				selected: this.search.formtypes,
				data: this.formtypes,
				idProperty: "value",
				captionKey: "text",
				selectAllBtn: true
			});
		},
		removeFormtype(selection) {
			const self = this;
			self.search.formtypes.find((formtype, i) => {
				if (formtype.value  === selection.value) {
					self.$delete(self.search.formtypes, i);
					self.updateSearch();
					return true;
				}
			});
			return false;
		},
		selectForm() {
			const self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: "Select a form",
				selectCallback: function (selection) {
					const isSelected = self.search.forms.find((form, i) => {
						if (form.id === selection.id) {
							self.$delete(self.search.forms, i);
							return true;
						}
					});
					if (!isSelected) {
						self.search.forms.push(selection);
					}
					self.updateSearch();
				},
				selected: this.search.forms,
				data: this.forms,
				captionKey: "title",
				selectAllBtn: true
			});
		},
		removeForm(selection) {
			const self = this;
			self.search.forms.find((form, i) => {
				if (form.id === selection.id) {
					self.$delete(self.search.forms, i);
					self.updateSearch();
					return true;
				}
			});
			return false;
		},
		toggleAdvancedSearch(){
			if(this.showadvancedsearch){
				localStorage.removeItem('cafs_forms_savedsearch');
				this.setSearchDefaults();
				this.showadvancedsearch = false;
				this.getFormResponses();
			} else {
				this.showadvancedsearch = true;
			}
		},
		updateSearch() {
			var body = JSON.parse(JSON.stringify(this.search));
			body.q = null;
			localStorage.setItem('cafs_forms_savedsearch', JSON.stringify(body));
			this.getFormResponses();
		},
		tryGetSavedSearch(){
			var savedsearch = localStorage.getItem('cafs_forms_savedsearch');
			var data = JSON.parse(savedsearch);
			if(data){
				for(var key in data){
					this.search[key] = data[key];
				};
				if(this.canViewAllForms) {
					this.showadvancedsearch = true;
				}
			}
		},
		newSearch() {
			this.getFormResponses();
		},
		setSearchDefaults(){
			this.search = {
				q: "",
				students: [],
				teachers: [],
                subjects: [],
				completed: "",
				reviewed: "",
				signedoff: "",
				workflows: [],
				forms: [],
				programme: null ,
				year: null ,
				group: null ,
				workbookid: null ,
				date_from: null ,
				date_to: null ,
				savedreport: null
			};
			for(var key in this.search){
				if(key in this.$route.query){
					this.search[key] = this.$route.query[key];
				}
			};
		},
		getFormResponses() {
			let body = {};
			if(this.search.q){
				body = {
					q: this.search.q
				}
			} else {
				body = {
					student: this.reduceUsers(this.search.students) ,
					teacher: this.reduceUsers(this.search.teachers) ,
                    subject: this.reduceUsers(this.search.subjects),
					signedoff: this.search.signedoff ? this.search.signedoff : "",
					completed: this.search.completed ? this.search.completed : "",
					workflow: this.search.workflows.map(workflow => workflow.id),
					form: this.search.forms.map(form => form.id),
					programme: this.search.programme ? this.search.programme.Id : '' ,
					year: this.search.year ,
					group: this.search.group ,
					workbookid: this.search.workbookid ,
					date_from: this.search.date_from,
					date_to: this.search.date_to,
					savedreport: this.search.savedreport
				};
			}
			this.$refs.infinitescroll.getData("replace", body);
		},
		reduceUsers(input) {
			if(input && input.length){
				return input.reduce(function(output, user){
					if(user && 'id' in user){ output.push(user.id); }
					return output;
				}, []);
			}
			return [];
		},
		downloadFormResponses(format) {
			let body = {};
			if(this.search.q){
				body = {
					q: this.search.q
				}
			} else {
				body = {
					username: this.$UserSession.getValue.call(this, "username"),
					authToken: this.$UserSession.getValue.call(this, "authToken"),
					download: JSON.stringify({
						student: this.search.students.map(student => student.id),
						teacher: this.search.teachers.map(teacher => teacher.id),
                        subject: this.search.subjects.length >0 ? this.search.subjects.map(student => student.id) : [],
						signedoff: this.search.signedoff ? this.search.signedoff : "",
						completed: this.search.completed ? this.search.completed : "",
						workflow: this.search.workflows.map(workflow => workflow.id),
						form: this.search.forms.map(form => form.id),
						programme: this.search.programme ? this.search.programme.Id : '' ,
						year: this.search.year ,
						group: this.search.group ,
						workbookid: this.search.workbookid ,
						date_from: this.search.date_from,
						date_to: this.search.date_to,
						savedreport: this.search.savedreport,
						format: format
					})
				};

    			const url = `${this.dataUrl}?` + new URLSearchParams(body).toString();
    			//alert(url);
    			window.open(url);

    			//let routeData = this.$router.resolve({href: `${this.$settings.APIBaseURL}/forms/response/listall?`, query: body});
    			//alert(routeData.href);
				//window.open(routeData.href, '_blank');

			}
		},
		selectFormResponse(formresponse) {
			if(formresponse.savedreport && formresponse.num_users > 1){
				var completedparam = '';
				if(this.search.completed){
					completedparam = '&completed=y';
				} else {
					completedparam  = '&completed=n';
				}
				this.$router.push(`/forms/list?savedreport=${formresponse.savedreport.savedreport_id}${completedparam}&submitter=${this.$UserSession.getValue('id')}`);
			} else {
				this.$router.push(`/forms/view/${formresponse.formresponse_id}`);
			}
		}
	},
	computed: {
		dataUrl() {
			return `${this.$settings.APIBaseURL}/forms/response/list${this.$route.params.list ? this.$route.params.list : ''}`;
		},
		canViewAllForms() {
			return !this.$route.params.list && this.$UserSession.hasPriv.call(this, "VIEW_ALLFORMS");
		}
	}
};
</script>
